// import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';

interface ConfirmDeleteModalProps {
    isOpen: boolean;
    type: 'pos' | 'branch' | null;
    isProcessing: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmDeleteModal = ({ 
    isOpen, 
    type, 
    isProcessing, 
    onClose, 
    onConfirm 
}: ConfirmDeleteModalProps) => {
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-[400px] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="p-6 text-center sm:p-7">
                    <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 rounded-full">
                        <AlertCircle className="text-red-600" size={24} />
                    </div>
                    <h3 className="mb-2 text-lg font-bold text-gray-900">
                        {type === 'pos' ? '¿Dar de baja Punto de Venta?' : '¿Dar de baja Sucursal Completa?'}
                    </h3>
                    <p className="text-[13px] text-gray-600 leading-relaxed">
                        {type === 'pos' 
                            ? 'Esta acción inhabilitará este punto de venta para la emisión de facturas. El registro quedará en el historial para auditoría.'
                            : 'Esta acción inhabilitará la sucursal y todos los puntos de venta asociados a ella de forma permanente.'}
                    </p>
                </div>

                <div className="flex items-center justify-center gap-3 px-6 py-4 bg-gray-50 border-t border-gray-100">
                    <button
                        onClick={onClose}
                        disabled={isProcessing}
                        className="w-full px-4 py-2 text-[13px] font-semibold text-gray-600 transition-colors bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isProcessing}
                        className="flex items-center justify-center w-full gap-2 px-4 py-2 text-[13px] font-semibold text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
                    >
                        {isProcessing ? (
                            <>
                                <Loader2 size={16} className="animate-spin" /> Procesando...
                            </>
                        ) : (
                            'Sí, dar de baja'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};